/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum SessionOrigin {
  EMBED = 'embed',
  STOREFRONT = 'storefront',
  EXPERIENCE_PAGE = 'experience_page',
}
